var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldAudioSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34 15.262c0 .74.6 1.33 1.33 1.33.74 0 1.34-.6 1.34-1.33 0-.74-.6-1.34-1.34-1.34-.74 0-1.33.6-1.33 1.34z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm8.61 9.27c-.28.2-.62.31-.98.31a2.1 2.1 0 0 1-.64-.11l-2.29-.76c-.01 0-.03-.01-.04-.02v4.56c0 1.54-1.26 2.8-2.8 2.8-1.54 0-2.8-1.26-2.8-2.8 0-1.54 1.26-2.8 2.8-2.8.49 0 .94.14 1.34.35V8.02c0-.61.26-1.15.7-1.47.45-.32 1.04-.4 1.62-.2l2.29.76c.86.29 1.51 1.19 1.51 2.09v.6h-.01c0 .61-.26 1.15-.7 1.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAudioSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-audio-square.263ce5ea61b4c4a744bfe0c753c48aeb.svg";
export { ForwardRef as ReactComponent };